/**
 * Internal helper for the Events hub services (not exported from the barrel).
 */
/** Return response.data or throw `message` when the envelope carries no data. */
export function unwrapEventsResponse(response, message) {
    if (response.data === undefined || response.data === null)
        throw new Error(message);
    return response.data;
}
//# sourceMappingURL=unwrapEventsResponse.js.map